import { render, staticRenderFns } from "./ModalCardAula.vue?vue&type=template&id=b6cbaa7a&scoped=true&"
import script from "./ModalCardAula.vue?vue&type=script&lang=js&"
export * from "./ModalCardAula.vue?vue&type=script&lang=js&"
import style0 from "./ModalCardAula.vue?vue&type=style&index=0&id=b6cbaa7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cbaa7a",
  null
  
)

export default component.exports